import React from "react";
import RangeFilter from "./RangeFilter";

export default function DepthRangeFilter({
    minValue,
    maxValue,
    minDepth,
    maxDepth,
    ...props
}) {
    return (
        <RangeFilter
            rangeMin={0}
            rangeMax={100}
            breakPoint={25}
            seg1Ratio={2 / 3}
            seg2Ratio={1 / 3}
            step={1}
            ticks={[0, 25, 100]}
            unit="м"
            minInputName="min-depth"
            maxInputName="max-depth"
            minAriaLabel="Глубина от, м"
            maxAriaLabel="Глубина до, м"
            {...props}
            minValue={minValue ?? minDepth ?? ""}
            maxValue={maxValue ?? maxDepth ?? ""}
        />
    );
}
